import { Injectable } from '@angular/core';
import { UserService } from '../../../data/repositories/user/user.service';


@Injectable({
  providedIn: 'root'
})
export class UserInfoService {
  public userData: any;

  constructor(private userService: UserService) {
  }
  private fetchUserdata() {
    return new Promise((resolve, reject) => {
      this.userService.getUserInfo((res: any) => {
        if (typeof res.is_error !== 'undefined' && res.is_error === false) {
          this.userData = res.api_response;
          resolve(res.api_response);
        } else {
          reject({ email: '', name: '' });
        }
      });
    });
  }

  public getUserData() {
    if (typeof this.userData !== 'undefined') {
      return Promise.resolve(this.userData);
    }
    return this.fetchUserdata();
  }
}
